import { Injectable, inject } from "@angular/core";
import { CoreUserProfileService } from "@ftr/owa-core";
import { Observable, map } from "rxjs";

@Injectable()
export class ProfileResolver  {
    private readonly coreUserProfile = inject(CoreUserProfileService);

    resolve(): boolean | Observable<boolean> | Promise<boolean> {
        return this.coreUserProfile.getProfile().pipe(map(() => true));
    }
}